<template>
    <div>
        <v-select
            v-if="!buttons && !autocomplete && !iterator"
            :items="locations"
            :value="multiple ? value : value[0]"
            :return-object="!idOnly"
            :disabled="disabled"
            :multiple="multiple"
            :rules="rules"
            item-text="name"
            item-value="id"
            prepend-inner-icon="storefront"
            outlined
            dense
            label="Location"
            v-on:input="$emit('input', multiple ? $event : [$event])"
        />
        <v-list v-if="buttons"
            ><v-list-item v-for="location in locations" :key="location.id">
                <SoliAvatarBtn
                    :avatar="
                        location.alt_image
                            ? `${location.alt_image}/m/80x80`
                            : '/musicologie-m-white.png'
                    "
                    :title="location.name"
                    :loading="location.id == value.id ? loading : false"
                    :trueDisabled="value?.id == location.id"
                    @click="$emit('input', location)"
                /> </v-list-item
        ></v-list>
        <v-autocomplete
            v-if="autocomplete && !buttons && !iterator"
            :value="value"
            :items="locations"
            :search-input.sync="search"
            :multiple="multiple"
            :loading="loading"
            :disabled="disabled"
            :rules="rules"
            hide-details="auto"
            prepend-inner-icon="storefront"
            return-object
            outlined
            :autofocus="autofocus"
            dense
            item-value="id"
            item-text="name"
            no-data-text="No locations found"
            label="Location"
            class="soli-blue-text"
            @input="
                (event) => {
                    if (event?.id) $emit('input', event);
                }
            "
            @keydown.enter.prevent
        >
            <template v-slot:item="data">
                <v-list-item-avatar>
                    <img
                        :src="
                            data.item.alt_image
                                ? `${data.item.alt_image}/m/80x80`
                                : '/musicologie-m-white.png'
                        "
                    />
                </v-list-item-avatar>
                <v-list-item-content
                    :class="{ 'disabled-item': data.item.disabled }"
                    class="max-w-min"
                >
                    <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                        data.item.address
                    }}</v-list-item-subtitle>
                    <v-list-item-subtitle>{{
                        data.item.phone
                    }}</v-list-item-subtitle>
                </v-list-item-content>
            </template>
        </v-autocomplete>
        <v-data-iterator
            v-if="iterator && !autocomplete && !buttons"
            :items="searchLocations"
            disable-pagination
            hide-default-footer
        >
            <template v-slot:header
                ><v-sheet light style="position: sticky; top: 0px; z-index: 10"
                    ><SoliText
                        v-model="search"
                        :loading="loading"
                        :autofocus="autofocus"
                        fullRound
                        label="Search Locations"
                        icon="storefront"
                        hideDetails
                        class="pa-3"
                        @keydown.enter="
                            searchLocations[0].id
                                ? $emit('input', searchLocations[0])
                                : null
                        "
                    /> </v-sheet
            ></template>
            <template v-slot:default="{ items }">
                <v-list
                    dense
                    class="soli-round divide-y py-0 overflow-auto mx-3"
                >
                    <v-list-item
                        v-for="(item, idx) in items"
                        :key="idx"
                        :input-value="!idx"
                        color="primary"
                        :class="{
                            'soli-grey': value.id !== item.id,
                        }"
                        class="location-list-item"
                        @click="$emit('input', item)"
                    >
                        <v-list-item-avatar size="56">
                            <img
                                :src="
                                    item.alt_image
                                        ? `${item.alt_image}/m/80x80`
                                        : '/musicologie-m-white.png'
                                "
                            />
                        </v-list-item-avatar>
                        <v-list-item-content :class="{ 'soli-grey': !!idx }">
                            <v-list-item-title class="font-weight-bold">{{
                                item.name
                            }}</v-list-item-title>
                            <v-list-item-subtitle>{{
                                item.phone
                            }}</v-list-item-subtitle>
                            <v-list-item-subtitle>{{
                                item.address
                            }}</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-icon
                                v-if="value.id === item.id"
                                small
                                color="primary"
                                >my_location</v-icon
                            ></v-list-item-action
                        >
                    </v-list-item>
                </v-list>
            </template></v-data-iterator
        >
    </div>
</template>

<script>
export default {
    props: {
        locations: {
            type: Array,
            default: () => [],
        },
        buttons: {
            type: Boolean,
            default: false,
        },
        iterator: {
            type: Boolean,
            default: false,
        },
        autocomplete: {
            type: Boolean,
            default: false,
        },
        rules: {
            type: Array,
            default: () => [],
        },
        loadLocations: {
            type: Boolean,
            default: false,
        },
        value: {
            type: [Object, Array],
            default: () => [],
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        idOnly: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
        blueShadow: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            search: "",
            //select: this.loadLocations ? this.locations : null,
        };
    },
    methods: {
        handleArrowNavigation(event) {
            const focusableElements = Array.from(
                document.querySelectorAll(".location-list-item")
            ).sort((a, b) => a.tabIndex - b.tabIndex);

            const currentIndex = focusableElements.indexOf(
                document.activeElement
            );

            if (event.key === "ArrowDown" || event.key === "ArrowRight") {
                event.preventDefault();
                const nextIndex = (currentIndex + 1) % focusableElements.length;
                focusableElements[nextIndex].focus();
            }

            if (event.key === "ArrowUp" || event.key === "ArrowLeft") {
                event.preventDefault();
                const prevIndex =
                    (currentIndex - 1 + focusableElements.length) %
                    focusableElements.length;
                focusableElements[prevIndex].focus();
            }
        },
    },
    computed: {
        searchLocations() {
            if (!this.search) {
                return this.locations;
            }
            return this.locations.slice().sort((a, b) => {
                const searchLower = this.search.toLowerCase();
                const aMatches = a.name.toLowerCase().includes(searchLower);
                const bMatches = b.name.toLowerCase().includes(searchLower);
                if (aMatches && !bMatches) {
                    return -1;
                }
                if (!aMatches && bMatches) {
                    return 1;
                }
                return 0;
            });
        },
    },
};
</script>
